export default __webpack_public_path__ + "static/media/HelveticaNeueBold.ca9d48aa.woff";